// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","container":"Modal_container__EY5Qx","content":"Modal_content__yBmFf","closeIcon":"Modal_closeIcon__PA6+Y"};